import React from 'react';
import Script from 'next/script';

import { IOutgrowFields } from '@/types/contentful';

export default function Chat({ code }: Partial<IOutgrowFields>) {
  return code ? (
    <>
      <div
        dangerouslySetInnerHTML={{ __html: code || '' }}
        data-testid="outgrow-chat"
      />
      <Script
        id="outgrow-chat"
        strategy="afterInteractive"
        src="https://dyv6f9ner1ir9.cloudfront.net/assets/js/chatV2.js"
      />
    </>
  ) : null;
}
